import { css } from 'styled-components';
import token from 'styled-token';
import { StyledTableBody } from '../../components/TableBody/TableBody.styles';
import { StyledTableCell } from '../../components/TableCell/TableCell.styles';
import { StyledTableHeader } from '../../components/TableHeader/TableHeader.styles';
import { StyledTableHeaderCell } from '../../components/TableHeaderCell/TableHeaderCell.styles';
import { StyledTableRow } from '../../components/TableRow/TableRow.styles';
import { tableResetMixin } from '../tableResetMixin';
import { typographyMixin } from '../typographyMixin';
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  return token({
    borderWidth: 'Table.borderWidth',
    borderColor: 'Table.borderColor',
    backgroundColor: 'Table.cellBackgroundColorLight',
    zebraBackgroundColor: 'Table.cellBackgroundColorDark'
  }, function (tokens) {
    var styles = [css(["", " ", "{background-color:", ";}"], StyledTableBody, StyledTableCell, tokens.backgroundColor)];
    switch (appearance) {
      case 'barebones':
        styles.push(css(["", " ", "{border-bottom:", "px solid ", ";}"], StyledTableHeader, StyledTableHeaderCell, tokens.borderWidth, tokens.borderColor));
        break;
      case 'horizontal':
        styles.push(css(["", "{border-bottom:", "px solid ", ";}"], StyledTableCell, tokens.borderWidth, tokens.borderColor));
        break;
      case 'zebra':
        styles.push(css(["", "{border-bottom:", "px solid ", ";}", " ", ":nth-child(2n) ", "{background-color:", ";}"], StyledTableCell, tokens.borderWidth, tokens.borderColor, StyledTableBody, StyledTableRow, StyledTableCell, tokens.zebraBackgroundColor));
        break;
      default:
        // default to "grid" styles
        styles.push(css(["&,", ",", "{border:", "px solid ", ";}"], StyledTableHeaderCell, StyledTableCell, tokens.borderWidth, tokens.borderColor));
        break;
    }
    return styles;
  })(props);
};
var sizeCSS = function sizeCSS(props) {
  var size = props.size;
  return token({
    verticalPadding: "Table.verticalPadding." + size,
    horizontalPadding: "Table.horizontalPadding." + size,
    fontType: "Table.fontType." + size,
    headerFontType: "Table.headerFontType." + size,
    fontWeights: 'fontWeights'
  }, function (tokens) {
    return css(["", "{padding:", "px ", "px;", "}", " ", "{", ";}"], StyledTableCell, tokens.verticalPadding, tokens.horizontalPadding, typographyMixin(Object.assign({
      fontType: tokens.fontType
    }, props)), StyledTableHeader, StyledTableHeaderCell, tokens.headerFontType && "font-weight: " + tokens.fontWeights[tokens.headerFontType]);
  })(props);
};
var alignmentsCSS = function alignmentsCSS(_ref) {
  var alignments = _ref.alignments;
  /* Set alignment styles here instead of in Table.Cell to
    ensure they get applied to dynamically-added rows:
    https://gitlab.zgtools.net/constellation/constellation/-/merge_requests/82 */
  var styles = [];
  for (var i = 0; i < alignments.length; i += 1) {
    styles.push(css(["", ":nth-child(", "){text-align:", ";}"], StyledTableCell, i + 1, alignments[i]));
  }
  return styles;
};

/** @class TableMixin */
/** @method */
export var TableMixin = function TableMixin(props) {
  return [tableResetMixin(props), appearanceCSS(props), sizeCSS(props), alignmentsCSS(props)];
};